import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Hint, Inscription, Text, useResponsive } from '@common-fe/common-fe';

import { useManageProfileModalsStore } from '@/modules/user/components/ManageProfile/stores/useManageProfileModals.store';

interface Props {
  hasAllowedPaymentMethods?: boolean;
}

const ReimbursementOptionsHeader: React.FC<Props> = ({ hasAllowedPaymentMethods }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { handleSetIsAddPaymentMethodModalVisible } = useManageProfileModalsStore();

  const handleOpenAddPaymentMethodModal = useCallback(() => {
    handleSetIsAddPaymentMethodModalVisible(true);
  }, [handleSetIsAddPaymentMethodModalVisible]);

  return (
    <Box direction="row" justify="between" align="center">
      {!isMobile && (
        <Inscription size="large" weight={700}>
          {t('Reimbursement options')}
        </Inscription>
      )}

      <Hint
        hintAlign="left"
        hintWidth={200}
        hideHint={hasAllowedPaymentMethods}
        marginContent="m"
        hintElement={
          <AppButton
            fill={isMobile}
            buttonType="secondary"
            onClick={handleOpenAddPaymentMethodModal}
            disabled={!hasAllowedPaymentMethods}
          >
            {t('Add Payment Method')}
          </AppButton>
        }
      >
        <Box direction="row" justify="center" align="center">
          <Text size="small" textAlign="center">
            {t('There are no more available payment methods.')}
          </Text>
        </Box>
      </Hint>
    </Box>
  );
};

export default ReimbursementOptionsHeader;
